import React from "react";
import { FaFilePdf } from "react-icons/fa";
import englishGRFile from "../../assets/documents/Gateway_GR.pdf";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../../components/marathiNumbers";
import { Link } from "react-router-dom";

const EventPermission = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const content = {
    English: {
      title: "Event Permission",
      divisionTitle: "HOME",
      breadcrumb: "EVENT PERMISSION",
      paragraph: `The 'Gateway of India'; emblem of the city of Mumbai, is a Category “A” State Protected Monument of the Directorate of Archaeology and Museums, Government of Maharashtra. The Directorate; every year, receives a large number of requests from  various government institutions, non-governmental organizations (NGOs) and private organizations to conduct programs in the vicinity of the said memorial. `,
      paragraph1: `To facilitate the process of permissions and fix revised rules for organizing such programs in the memorial premises, the Government of Maharashtra has issued a Government Resolution, Tourism and Cultural Affairs Department क्र. पुवसं-२०१८/प्र. क्र.०७/सां. का.३, dated 15th February, 2018.`,
      paragraph2: `The Organisations/Institutions and anyone requesting permissions to organise programs and events on the premises of Gateway of India and its immediate vicinity need to follow the process as mentioned in the GR and need to send a request letter preferably by hand or through email. Details of address and email are as mentioned in Contact Us of the Directorate Website.`,
      loginText: "LOG IN",
    },

    मराठी: {
      title: "कार्यक्रमासाठी परवानगी",
      divisionTitle: "मुख्यपृष्ठ ",
      breadcrumb: "कार्यक्रमासाठी परवानगी",
      paragraph: `मुंबई शहराचे मानचिन्ह असलेला ‘गेटवे ऑफ इंडिया हे पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, महाराष्ट्र शासन यांचे  “अ” दर्जाचेराज्य संरक्षित स्मारक आहे. सदर स्मारकाच्या परिसरामध्ये विविध कार्यक्रम इत्यादी आयोजित करण्यासाठी दरवर्षी खुपश्या शासकीय तसेच अशासकीय, स्वंयसेवी संस्था (NGO) आणि खासगी संस्था यांच्याकडून मोठ्या प्रमाणात विनंतीपत्रे प्राप्त होत असतात. तरी अशा प्रकारचे कार्यक्रम स्मारक परिसरात आयोजित करण्याकरिता सुधारीत नियमावली निश्चित करण्याचा  अनुषंगाने शासनाने शासन निर्णय, पर्यटन व सांस्कृतिक कार्य विभाग क्र. पुवसं-२०१८/प्र. क्र.०७/सां. का.३, दि. १५ फेब्रुवारी, २०१८ अन्वये अधिक्रमित करून निर्णय घेतला आहे.`,
      paragraph1: ` तरी अश्या संस्था इत्यादींना जर गेटवे ऑफ इंडिया परिसरात कार्यक्रम आयोजित करावयाचे असतील त्यांना वरील शासन निर्णयाच्या अधीन राहून पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, महाराष्ट्र शासन यांच्या मुख्यालयात हाती अथवा ईमेलने परवानगीसाठी विनंती पत्र पाठवणे जरुरी आहे. मुख्यालयाचा पत्ता आणि ईमेल संकेतस्थळावर संपर्क साधा या दुव्याखाली उपलब्ध आहे.`,
      loginText: "लॉग इन",
    },
  };

  const tableHeaders = {
    srNo: {
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    name: {
      English: "Name",
      मराठी: "नाव",
    },
    download: {
      English: `Download`,
      मराठी: `डाउनलोड`,
    },
  };

  const downloadData = [
    {
      id: 1,
      name: {
        English: "Gateway of India GR",
        मराठी: "गेटवे ऑफ इंडिया शासन निर्णय",
      },
      download: englishGRFile,
    },
  ];

  const t = content[selectedLang];

  const handleClick = () => {
    window.open('https://gateway.fresherszone.in/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.divisionTitle}
            </Link>{" "}
            /{" "}
          </span>
          <span>{t.breadcrumb}</span>
        </p>
      </div>

      {/* Description Section */}
      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black leading-relaxed space-y-4 mt-12 font-futura">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph}
        </p>

        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph1}
        </p>

        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph2}
        </p>
      </div>

      {/* Download Section */}
      <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-8 mt-14">
        {t.downloadTitle}
      </h2>
      <div className="max-w-5xl mx-auto overflow-x-auto no-dark-bg">
        <div
          className="bg-[#EFEDE0] rounded-xl overflow-hidden" style={{ border: "2px solid #F8D6BF" }}
        >
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead
              className="font-bold tracking-wide"
              style={{
                textShadow: "0.3px 0.3px 0 black",
              }}
            >
              <tr>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.srNo[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.name[selectedLang]}
                </th>
                <th
                  className="py-3 px-4"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.download[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {downloadData.map((item, index) => (
                <tr key={item.id} className="hover:bg-[#F6F6EC]" >
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {selectedLang === "मराठी"
                      ? convertToMarathiNumber(index + 1)
                      : `${index + 1}`}
                    .
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {item.name[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    <div className="flex justify-center items-center h-full">
                      <a
                        href={item.download}
                        download="Event Permission GR"
                        title="Download PDF"
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaFilePdf size={20} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-4">
        <button
          className="mt-3 sm:mt-5 px-3 sm:px-5 py-1 sm:py-2 text-[13px] sm:text-[11px] md:text-sm bg-transparent border border-black 
                    rounded-full  hover:bg-orange-500 hover:text-white hover:border-transparent transition font-futura font-semibold tracking-widest"
          onClick={handleClick}>
          {t.loginText}
        </button>
      </div>
    </div>
  );
};

export default EventPermission;
